import { BrowserRouter, Routes, Route } from "react-router-dom";
import NotFound from "./pages/error/404";
import Layout from "./components/layout/Layout";
import VisualizarArchivos from "./pages/visualizar-archivos/Main";
import Login from "./pages/auth/Login";
import SignOutRoutes from "./components/layout/SignOutRoutes";
import Search from "./pages/search/index";
import ProtectedRoutes from "./components/layout/ProtectedRoutes";
import React, { FunctionComponent } from "react";
import allRoutes from "./components/layout/rutas-modulos/RutasSistema";
import FileApiViewer from "./pages/visualizar-archivos/FileApiViewer";

export default function Router() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route element={<SignOutRoutes />}>
            <Route path="/busqueda-documentos" element={<Search />} />
            <Route path="/auth" element={<Login />} />
          </Route>

          <Route path="/file/:file" element={<FileApiViewer />} />

          {/* Rqueire autentication */}
          <Route element={<ProtectedRoutes />}>
            <Route path="/" element={<VisualizarArchivos />} />
            <Route path="/search" element={<Search />} />
            {allRoutes.map(
              (
                {
                  path,
                  elemento,
                }: { path: string; elemento: FunctionComponent },
                ix: number
              ) => (
                <Route
                  path={path}
                  element={React.createElement(elemento)}
                  key={"rt" + ix + path}
                  caseSensitive
                />
              )
            )}
          </Route>

          <Route path="/*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
